import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import { provideEnvironmentNgxCurrency } from '@dintecom/ngx-currency';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home/home.component';
import { NovoContatoComponent } from './home/register-data/contatos/novo-contato/novo-contato.component';
import { ContatoDetalhesComponent } from './home/register-data/contatos/detalhes/contato-detalhes.component';
import { NewAddressComponent } from './home/register-data/addresses/new-address/new-address.component';
import { AddressDetailsComponent } from './home/register-data/addresses/address-details/address-details.component';
import { NetworkInterceptor } from './interceptor/network.interceptor';
import { AreaRestritaComponent } from './home/billboard/area-restrita/area-restrita.component';
import { QuadroDeAvisosComponent } from './home/billboard/quadro-de-avisos/quadro-de-avisos.component';
import { NovaOcorrenciaComponent } from './home/occurrence/nova-ocorrencia/nova-ocorrencia.component';
import { AlterarSenhaComponent } from './home/navigation/alterar-senha/alterar-senha.component';
import { FaleConoscoComponent } from './home/navigation/fale-conosco/fale-conosco.component';
import { AcompanhamentoComponent } from './home/occurrence/acompanhamento/acompanhamento.component';
import { HistoricoDeOcorrenciasComponent } from './home/occurrence/historico-de-ocorrencias/historico-de-ocorrencias.component';
import { RequestInterceptor } from './interceptor/request.interceptor';
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SafePipe } from './safe.pipe';
import { VbAbastecimentoComponent } from './home/occurrence/vb-abastecimento/vb-abastecimento.component';
import { VtonlineComponent } from './vtonline/vtonline.component';
import { TermoBannerAceitavelComponent } from './home/termos/termo-banner-aceitavel/termo-banner-aceitavel.component';
import { TermoFidelidadeComponent } from './home/termos/termo-fidelidade/termo-fidelidade.component';
import { TermoGenericoComponent } from './home/termos/termo-generico/termo-generico.component';
import { TermoPremmiarComponent } from './home/termos/termo-premmiar/termo-premmiar.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { ReprocessamentoComponent } from './home/requests/historico/reprocessamento/reprocessamento.component';
import { ThemeService } from './services/theme/theme.service';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { FaviconService } from './services/favicon/favicon.service';
import { TimeoutComponent } from './timeout/timeout.component';
import { Doutor123Component } from './home/requests/gerar-pedidos/doutor123/doutor123.component';
import { HistoricoRelatoriosComponent } from './home/reports/historico-relatorios/historico-relatorios.component';
import { TokenChangeService } from './interceptor/session.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OnlyConfirmDialigComponent } from './shared/components/only-confirm-dialig/only-confirm-dialig.component';
import { BasicDialogComponent, DialogData } from './shared/componentes/basic-dialog/basic-dialog.component';
import { LoginService } from './services/login/login.service';
import { DemonstrativoComponent } from './demonstrativo/demonstrativo.component';
import { ImprimirBoletoPublico } from './boleto/imprimir-boleto.component';
import { ImportarArquivoV2Component } from './home/imports-page-v2/importar-arquivo-v2/importar-arquivo-v2.component';
import { VerificarDadosImportadosV2Component } from './home/imports-page-v2/verificar-dados-importados-v2/verificar-dados-importados-v2.component';
import { ImportarCsvV2Component } from './home/imports-page-v2/importar-csv-v2/importar-csv-v2.component';
import { ImportarPadraoV2Component } from './home/imports-page-v2/importar-padrao-v2/importar-padrao-v2.component';
import { ImportarPersonalizadaV2Component } from './home/imports-page-v2/importar-personalizada-v2/importar-personalizada-v2.component';
import { PublicacaoComponent } from './publicacao/publicacao.component';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getPaginatorIntl } from './paginator-intl';
import { RippleGlobalOptions, MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { ResumoItensImportadosComponent } from './home/imports-page-v2/resumo-itens-importados/resumo-itens-importados.component';
import { SharedModule } from './shared/shared.module';
import { OcorrenciaComponent } from './home/occurrence/ocorrencia.component';
import { EmissoresDialogComponent } from './home/emissores-dialog/emissores-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SvgIconService } from './services/icons/svg-icon.service';
import { ThemeLoaderService } from './services/theme-loader/theme-loader.service';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { ImportarCsvPersonalizadoComponent } from './home/imports-page-v2/importar-csv-personalizado/importar-csv-personalizado.component';
import { StepHeaderComponent } from './home/cartoes/cartoes-multi/transferencia-bolsao-lote/steps/step-header/step-header.component';
import { StepContentComponent } from './home/cartoes/cartoes-multi/transferencia-bolsao-lote/steps/step-content/step-content.component';
import { StepUploadComponent } from './home/imports-page-v2/importar-csv-personalizado/step-upload/step-upload.component';
import { StepProcessingComponent } from './home/imports-page-v2/importar-csv-personalizado/step-processing/step-processing.component';
import { StepResultComponent } from './home/imports-page-v2/importar-csv-personalizado/step-result/step-result.component';
import { NgxSkeletonLoaderModule, provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MenuItemComponent } from './home/home/menu-item/menu-item.component';

// REGISTRA O LOCALE
registerLocaleData(localePt);
const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 300,
    exitDuration: 0
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MenuItemComponent,
    NovoContatoComponent,
    ContatoDetalhesComponent,
    NewAddressComponent,
    AddressDetailsComponent,
    AreaRestritaComponent,
    QuadroDeAvisosComponent,
    DashboardComponent,
    NovaOcorrenciaComponent,
    AlterarSenhaComponent,
    NovaOcorrenciaComponent,
    FaleConoscoComponent,
    AcompanhamentoComponent,
    HistoricoDeOcorrenciasComponent,
    SafePipe,
    VbAbastecimentoComponent,
    ResumoItensImportadosComponent,
    VtonlineComponent,
    TermoBannerAceitavelComponent,
    TermoFidelidadeComponent,
    TermoGenericoComponent,
    TermoPremmiarComponent,
    PdfViewerComponent,
    ReprocessamentoComponent,
    TimeoutComponent,
    Doutor123Component,
    HistoricoRelatoriosComponent,
    DemonstrativoComponent,
    ImprimirBoletoPublico,
    ImportarArquivoV2Component,
    VerificarDadosImportadosV2Component,
    ImportarCsvV2Component,
    ImportarPadraoV2Component,
    ImportarCsvPersonalizadoComponent,
    ImportarPersonalizadaV2Component,
    PublicacaoComponent,
    OcorrenciaComponent,
    EmissoresDialogComponent
  ],
  imports: [
    AppRoutingModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgxMaskDirective,
    MatIconModule,
    MatChipsModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    StepHeaderComponent,
    StepContentComponent,
    StepUploadComponent,
    StepProcessingComponent,
    StepResultComponent
  ],
  providers: [
    // Zone CD only in main.ts applicationProviders (Angular 22 NgModule requirement).
    provideEnvironmentNgxMask(),
    provideEnvironmentNgxCurrency({
      align: 'left',
      allowNegative: false,
      allowZero: true,
      decimal: ',',
      precision: 2,
      prefix: 'R$ ',
      suffix: '',
      thousands: '.',
      nullable: true
    }),
    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        'margin-bottom': '0px',
        'background-color': '#f6f6f6'
      }
    }),
    provideAppInitializer(async () => {
      const svgIconService = inject(SvgIconService);
      const themeLoaderService = inject(ThemeLoaderService);

      // Never reject: a failed icons HTTP call would abort bootstrap and leave
      // spe-root at opacity:0 forever (index.html FOUC guard).
      try {
        await svgIconService.registerIcons();
      } catch (err) {
        console.error('[APP_INITIALIZER] registerIcons failed', err);
      }

      try {
        await themeLoaderService.initTheme();
      } catch (err) {
        console.error('[APP_INITIALIZER] initTheme failed', err);
      }
    }),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    { provide: MatPaginatorIntl, useValue: getPaginatorIntl() },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  private dialogReference?: MatDialogRef<BasicDialogComponent, any>;
  constructor(
    private themeService: ThemeService,
    private routerService: Router,
    private favIconService: FaviconService,
    private tokenChangeService: TokenChangeService,
    private dialog: MatDialog,
    private loginService: LoginService
  ) {
    let subs = this.routerService.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((e) => {
      if (localStorage.getItem('token') == null) {
        if (Object(e).url.includes('caixa')) {
          this.themeService.setBrandTheme('cef');
          this.favIconService.changeFavicon('assets/favicon/favicon2.png');
          this.favIconService.changeTitle('CAIXA');
        } else if (Object(e).url.includes('login')) {
          this.favIconService.changeFavicon('assets/favicon/favicon1.png');
          this.favIconService.changeTitle('Sem Parar - Empresas');
        }
      }
      subs.unsubscribe();
    });

    if (localStorage.getItem('BRAND-THEME') == 'cef' && localStorage.getItem('token') != null) {
      // themeService.setBrandTheme('cef');
    }

    this.tokenChangeService.getTokenChangeObservable().subscribe(() => {
      this.dialog.closeAll();
      this.dialogReference = this.dialog.open(BasicDialogComponent, this.createDialogConfig());
      this.dialogReference.afterClosed().subscribe(() => {
        this.loginService.logoutAndRedirect();
      });
    });
  }

  private readonly createDialogConfig = (): Object => {
    const dialogData: DialogData = {
      title: 'Sessão expirada',
      message: 'Você realizou o login em outra aba, estamos redirecionando você para o login mais recente!',
      action1: 'OK',
      icon: 'error'
    };
    return { panelClass: 'full-bleed-dialog', width: '300px', data: dialogData };
  };
}
